import { render, staticRenderFns } from "./myFunds.vue?vue&type=template&id=3ada1294&scoped=true&"
import script from "./myFunds.vue?vue&type=script&lang=js&"
export * from "./myFunds.vue?vue&type=script&lang=js&"
import style0 from "./myFunds.vue?vue&type=style&index=0&id=3ada1294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada1294",
  null
  
)

export default component.exports